import { useEffect } from "react";

export default function WatomsPdmsReportSheet({ open, title = "تقرير", onClose, children, footer }) {
  // Lock body scroll + close on ESC
  useEffect(() => {
    if (!open) return;

    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    const onKeyDown = (e) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", onKeyDown);

    return () => {
      document.body.style.overflow = prevOverflow;
      window.removeEventListener("keydown", onKeyDown);
    };
  }, [open, onClose]);

  if (!open) return null;

  const handlePrint = () => window.print();

  return (
    <div className="fixed inset-0 z-50">
      {/* Backdrop */}
      <div
        className="absolute inset-0 bg-black/60"
        onClick={onClose}
      />

      {/* Modal wrapper */}
      <div className="relative h-full w-full overflow-auto p-4 sm:p-8">
        <div className="mx-auto flex max-w-[950px] flex-col items-center gap-3">
          
          {/* Top controls (hidden when printing) */}
          <div className="no-print flex w-full items-center justify-between rounded-xl bg-zinc-900/70 p-3 backdrop-blur">
            <div>
              <div className="text-sm font-semibold text-white">{title}</div>
              <div className="text-xs text-zinc-300">
                A4 preview • ready for print
              </div>
            </div>

            <div className="flex gap-2">
              <button
                onClick={handlePrint}
                className="rounded-lg bg-white px-3 py-1.5 text-sm font-medium text-zinc-900 hover:bg-zinc-100"
              >
                Print
              </button>
              <button
                onClick={onClose}
                className="rounded-lg border border-white/20 px-3 py-1.5 text-sm text-white hover:bg-white/10"
              >
                Close
              </button>
            </div>
          </div>

          {/* A4 Sheet */}
          <div
            id="a4-report"
            className="bg-white text-zinc-900 shadow-2xl w-[210mm] min-h-[297mm] overflow-hidden"
          >
            {/* Header */}
            {/* <div className="border-b px-10 py-6">
              <div className="flex justify-between">

              </div>
            </div> */}

            {/* Body */}
            <div className="px-10 py-8">
              {children}
            </div>

            {/* Footer */}
            {/* <div className="border-t px-10 py-4 text-sm text-zinc-600">
              {footer || (
                <div className="flex justify-between">
                  <span>Confidential</span>
                  <span>Page 1 of 1</span>
                </div>
              )}
            </div> */}
          </div>
        </div>
      </div>

      {/* Print styles */}
      <style>{`
        @media print {
          .no-print { display: none !important; }

          body * {
            visibility: hidden;
          }

          #a4-report, #a4-report * {
            visibility: visible;
          }

          #a4-report {
            position: fixed;
            inset: 0;
            margin: 0 auto;
            width: 210mm;
            min-height: 297mm;
            box-shadow: none !important;
          }

          @page {
            size: A4;
            margin: 12mm;
          }
        }
      `}</style>
    </div>
  );
}